import React, { useContext } from "react";
import { AppContext } from "../../context";
import ButtonRow from "./ButtonRow";

function AddToCart({ setIsAddedToCartVisible, handleAddToCart }) {
  const info = useContext(AppContext);
  return (
    <>
      <div
        className="reservation-question"
        style={{ padding: "16px 16px 6px 16px" }}
      >
        {info.t("toAddToCart")}
      </div>
      <ButtonRow
        btn1Text={info.t("cancel")}
        btn1Action={() => setIsAddedToCartVisible(false)}
        btn2Text={info.t("reserve")}
        btn2Action={() => handleAddToCart()}
      />
    </>
  );
}

export default AddToCart;
